import React, { memo } from 'react'
import Typography from '@ntuctech/devex-tangram/Typography'
import PromptPlusCard from '../PromptPlusCard'
import SelectOtpMethod from '../SelectOtpMethod'
import SessionTimeoutNotification from '../SessionTimeoutNotification'
import VerifyOtp from '../verifyOtp'
import useUnionLoginHook, { FPM_CS_MSG } from '../hooks/useUnionLoginHook'
import { Wrapper, FPLogo, TermsConditions } from './elements'
import { Paper } from '../styled'

const LoginScreen = ({ isNewSession, ...props }) => {
  const [current, send] = useUnionLoginHook(props)

  return (
    <Wrapper>
      <FPLogo />
      <SessionTimeoutNotification
        hidden={isNewSession || !current.matches('promptPlusCard')}
      />
      <Paper className="styled-paper">
        <Typography variant="h2">Welcome to Fairprice Membership</Typography>
        {['promptPlusCard', 'verifyCardNumber'].some(current.matches) && (
          <PromptPlusCard
            cardInputHelpText={current.state.cardInputHelpText}
            isLoading={current.matches('verifyCardNumber')}
            plusCardNumber={current.state.plusCardNumber}
            send={send}
            showCardInfoModal={current.state.showCardInfoModal}
          />
        )}
        {current.matches('selectOtpMethod') && (
          <SelectOtpMethod
            maskedUserDetails={current.state.maskedUserDetails}
            otpMethods={current.state.otpMethods}
            send={send}
          />
        )}
        {['awaitingOtp', 'authenticated', 'requestOtp', 'verifyingOTP'].some(
          current.matches
        ) && (
          <VerifyOtp
            isVerifying={!current.matches('awaitingOtp')}
            maskedUserDetails={current.state.maskedUserDetails}
            otpInputHelpText={current.state.otpInputHelpText}
            otpNumber={current.state.otpNumber}
            selectedOtpMethod={current.state.selectedOtpMethod}
            send={send}
            setOtpNumber={value => send({ type: 'SET_OTP_NUMBER', value })}
          />
        )}
      </Paper>
      {current.state.showHelpBox && (
        <Paper className="styled-paper">
          <Typography variant="h6">Need Help?</Typography>
          <Typography>
            {['promptPlusCard', 'verifyCardNumber'].some(current.matches) &&
            current.state.cardInputHelpText !== FPM_CS_MSG ? (
              <>
                For checking of Link Rewards card number, please email to{' '}
                <a href={'mailto:enquiries@ntuclink.com.sg'}>
                  enquiries@ntuclink.com.sg
                </a>
                .
              </>
            ) : (
              <>
                Please contact our FairPrice Membership customer service at{' '}
                <a href={'tel:6380 5858'}>6380 5858</a> on Mon-Fri (except PH)
                9am to 5pm
              </>
            )}
          </Typography>
        </Paper>
      )}
      <TermsConditions />
    </Wrapper>
  )
}

export default memo(LoginScreen)
